// ─────────────────────────────────────────────────────────────────────────────
// Login error — an Okta redirect that came back with ?error= instead of ?code=.
//
// Okta answers that way when it accepted the request but will not issue tokens,
// most often access_denied for someone not assigned to the EntCat app. Treating
// it as "not signed in" sends them straight back to Okta, which still has their
// session and returns the same error: a redirect loop. main.tsx renders
// SignInError for it instead.
// ─────────────────────────────────────────────────────────────────────────────

/** Where SPS staff request EntCat access (Okta end-user catalog entry). */
export const REQUEST_ACCESS_URL =
  'https://mysps.spscommerce.com/enduser/resource/catalog/entry/cen1l6rwzFQpO8TOY4x6'

export interface LoginError {
  error:       string
  description: string | null
}

/**
 * Reads an OIDC error from a redirect's query string or hash.
 * Returns null when the URL carries no `error` parameter.
 */
export function readLoginError(search: string, hash = ''): LoginError | null {
  for (const part of [search, hash]) {
    const params = new URLSearchParams(part.replace(/^[?#]/, ''))
    const error = params.get('error')
    if (error) return { error, description: params.get('error_description') }
  }
  return null
}
